import React from "react";
import { node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { fontSizePropTypes } from "../props/sx";

const OListItem = ({ size, spacing = { ...spacingProps }, className = "", children }) => {
	return (
		<li className={classes("li", size && `text-${size}`, ...spacingClassName(spacing), className)}>
			{children}
		</li>
	);
};

OListItem.propTypes = {
	size: fontSizePropTypes,
	className: string,
	children: node.isRequired,
	spacing: spacingPropTypes,
};

const OList = ({
	type = "default",
	spacing = { ...spacingProps },
	className = "",
	children,
	...props
}) => {
	return (
		<ol className={classes("ol", `ol-${type}`, ...spacingClassName(spacing), className)} {...props}>
			{children}
		</ol>
	);
};

OList.propTypes = {
	type: oneOf([
		"default",
		"custom",
		"lower-alpha",
		"upper-alpha",
		"lower-roman",
		"decimal",
		"dotted",
	]),
	className: string,
	children: node.isRequired,
	spacing: spacingPropTypes,
};

OList.Item = OListItem;

export default OList;
